import { hamburguer, HamburguerVariantProps } from "./hamburguer.variants";

export type UseHamburguerProps = HamburguerVariantProps & {
  className?: string;
  ariaControls?: string;
  toggle: () => void;
};

export const useHamburguer = (props: UseHamburguerProps) => {
  const {
    className = "",
    active = false,
    theme = "light",
    ariaControls = "",
    toggle,
  } = props;

  const styles = hamburguer({
    active,
    theme,
  });

  const ariaLabel = active ? "Open menu" : "Close menu";

  return {
    styles,
    className,
    ariaLabel,
    ariaControls,
    active,
    toggle,
  };
};
